import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useMatchIdMapping } from "../../../../hooks/useMatchIdMapping.js";
import CalendarNavigation from "../../../../../components/Live/navigation/CalendarNavigation.js";
import { useNavigateTo } from "../../../../hooks/useNavigateTo.js";
import { MatchsDisplay } from "../matchs/MatchsDisplay.js";

const MultiplexCalendar = ({live, liveDates}) => {

    const navigateTo = useNavigateTo();
    const [matchIdMapping] = useMatchIdMapping(live)

    const { date } = useParams();

    const navigateToNewDate = (newDate) => {
        // Replace le segment /day/OLD_DATE par /day/NEW_DATE
        let newPath = window.location.pathname.replace(/\/calendar\/[^/]+/, `/calendar/${newDate}`);
      
        // Si un idMatch est présent à la fin (genre un Mongo ID), on le retire
        newPath = newPath.replace(/\/[0-9a-fA-F]{24}$/, '');
      
        navigateTo(newPath);
    };

    return <Box className='centered-wrapper column-wrapper'>
        <CalendarNavigation liveDates={liveDates} activeDate={date} setActiveDate={navigateToNewDate} />
        <Box className='medium-wrapper'></Box>
        <Box>
            <MatchsDisplay live={live}/>
        </Box>
        
    </Box>
}

export default MultiplexCalendar